import { Component, Input } from '@angular/core';

@Component({
  selector: 'via-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent {
  @Input()
  public blockSize = 45;

  public getContainerSize(): number {
    return this.blockSize * 2 + 3; //Add 3 for pixel space around and between blocks.
  }
}
